import { SEEK_LIMIT, SEEK_LIMIT_SUCCEEDED, SEEK_LIMIT_FAILED } from "constants/actionTypes.jsx"
import { UPDATE_SUGGESTIONS, UPDATE_SUGGESTIONS_SUCCEEDED, UPDATE_SUGGESTIONS_FAILED, FETCHING_SUGGESTIONS, FETCHING_SUGGESTIONS_SUCCEEDED, FETCHING_SUGGESTIONS_FAILED } from "constants/actionTypes.jsx"
import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const SEEK_LIMIT_BASE_URL = `${API_URL}/api/1.0/accounts`;
const SUGGESTIONS_BASE_URL = `${API_URL}/api/1.0/seek`;


export const seeklimits = createAction(SEEK_LIMIT);
const seeklimitSucceeded = createAction(SEEK_LIMIT_SUCCEEDED);
const seeklimitFailed = createAction(SEEK_LIMIT_FAILED);

function* fetchSeekLimit(action) {

    const id = action.payload.id;
    const userLimit = action.payload.userLimit;
    const visitorLimit = action.payload.visitorLimit;
    let request = {
        id,
        userLimit,
        visitorLimit
    }
    let url = buildUrl(`${SEEK_LIMIT_BASE_URL}/${id}/seek-limit`);


    const seekAPI = () => {
        return axios({
            method: "PUT",
            data:request,
            url: url
        }).then((response) => response.data);
    };

    try {
        const response = yield call(seekAPI);
        yield put(seeklimitSucceeded(response));
    } catch (error) {
        yield put(seeklimitFailed(error));
    }
}

//suggest questions

export const updateSuggestions = createAction(UPDATE_SUGGESTIONS);
const updateSuggestionsSucceeded = createAction(UPDATE_SUGGESTIONS_SUCCEEDED);
const updateSuggestionsFailed = createAction(UPDATE_SUGGESTIONS_FAILED);

function* fetchSuggestions(action) {

    const id = action.payload.id;

    const suggestions = action.payload.questionValues;

   let url = buildUrl(`${SUGGESTIONS_BASE_URL}/${id}/set-questions`);

   const suggestionsAPI = () => {
        return axios({
            method: "PUT",
            url: url,
            data: {
                suggestions
            }
        }).then((response) => response.data);
    };

    try {
        const response = yield call(suggestionsAPI);
        yield put(updateSuggestionsSucceeded(response));
    } catch (error) {
        yield put(updateSuggestionsFailed(error));
    }
}

// fetch suggestions
export const fetchingSuggestions = createAction(FETCHING_SUGGESTIONS);
const fetchingSuggestionsSucceeded = createAction(FETCHING_SUGGESTIONS_SUCCEEDED);
const fetchingSuggestionsFailed = createAction(FETCHING_SUGGESTIONS_FAILED);

function* fetchingSuggestionsQuestions(action) {

    const id = action.payload.id;
    let url = buildUrl(`${SUGGESTIONS_BASE_URL}/${id}/seek-questions`);
    const suggestionsAPI = () => {
        return axios({
            method: "GET",
            url: url,

        }).then((response) => response.data);
    };

    try {
        const response = yield call(suggestionsAPI);
        yield put(fetchingSuggestionsSucceeded(response));
    } catch (error) {
        yield put(fetchingSuggestionsFailed(error));
    }
}

export default function* seekLimitSaga() {

    yield takeLatest(SEEK_LIMIT, fetchSeekLimit);
    yield takeLatest(UPDATE_SUGGESTIONS, fetchSuggestions);
    yield takeLatest(FETCHING_SUGGESTIONS, fetchingSuggestionsQuestions);



}
